import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import styles from "../styles/pages/index.module.scss"
import { useForm } from "react-hook-form"
import Axios from "axios"

// IMAGES
import Hero from "../images/fallbacks/hero.jpg"
import AboutOne from "../images/fallbacks/about-one.jpg"
import AboutOneWebp from "../images/webp/about-one.webp"
import AboutOneSmall from "../images/fallbacks/about-one-small.jpg"
import AboutOneSmallWebp from "../images/webp/about-one-small.webp"
import AboutTwo from "../images/fallbacks/about-two.jpg"
import AboutTwoWebp from "../images/webp/about-two.webp"
import AboutTwoSmall from "../images/fallbacks/about-two-small.jpg"
import AboutTwoSmallWebp from "../images/webp/about-two-small.webp"
import AboutThree from "../images/fallbacks/about-three.jpg"
import AboutThreeWebp from "../images/webp/about-three.webp"
import AboutThreeSmall from "../images/fallbacks/about-three-small.jpg"
import AboutThreeSmallWebp from "../images/webp/about-three-small.webp"
import WhyJengaOne from "../images/why-jenga-one.svg"
import WhyJengaTwo from "../images/why-jenga-two.svg"
import WhyJengaThree from "../images/why-jenga-three.svg"
import ClientOne from "../images/logos/ABCexpat.png"
import ClientTwo from "../images/logos/altaroad.png"
import ClientThree from "../images/logos/artefact.png"
import ClientFour from "../images/logos/koko.png"
import ClientFive from "../images/logos/looksgood.jpg"
import ClientSix from "../images/logos/unblocked.png"
import WorksOne from "../images/works-one.svg"
import WorksTwo from "../images/works-two.svg"
import WorksThree from "../images/works-three.svg"
import WavyLineOne from "../images/wavy-line-one.svg"
import WavyLineTwo from "../images/wavy-line-two.svg"
import WavyLineThree from "../images/wavy-line-three.svg"
import WavyLineFour from "../images/wavy-line-four.svg"
import TickIcon from "../images/tick-icon.svg"
import StackOne from "../images/stacks/javascript.png"
import StackTwo from "../images/stacks/react.png"
import StackThree from "../images/stacks/vue.svg"
import StackFour from "../images/stacks/angular.svg"
import StackFive from "../images/stacks/python.svg"
import StackSix from "../images/stacks/django.svg"
import StackSeven from "../images/stacks/flask.svg"
import StackEight from "../images/stacks/node.svg"
import StackNine from "../images/stacks/aws.png"
import StackTen from "../images/stacks/gcp.png"
import StackEleven from "../images/stacks/postgresql.svg"
import StackTwelve from "../images/stacks/mysql.svg"
import Cecile from "../images/cecile.jpg"
import Sameer from "../images/sameer.jpeg"
import ChatStack from "../images/chat-stack.svg"
import SourceTrain from "../images/source-train.svg"
import HireOnboard from "../images/hire-onboard.svg"
import Deliver from "../images/deliver.svg"

const IndexPage = () => {
  const { handleSubmit, register } = useForm()

  const submitHandler = (values: any) => {
    console.log(values)

    Axios.post(
      "http://localhost:5001/jenga-site/us-central1/sendJoinEmail/contact",
      values
    ).then((res: any) => {
      console.log(res)
    })
  }

  return (
    <Layout>
      <SEO
        title="Hire Kenya’s top tech talent"
        description="Hire Kenya’s top tech talent with Jenga. Access an untapped talent pool and recruit the best software engineers for your team."
        meta={[
          {
            name: "keywords",
            content:
              "jenga, jenga agency, apps, build websites, build apps, jenga apps, jenga websites",
          },
        ]}
      />
      <section className={styles.heroWrapper}>
        <div className={styles.hero}>
          <h2 className={styles.heroTitle}>Hire Kenya’s Top Tech Talent</h2>
          <p className={styles.heroSubtitle}>
            Augment your tech team &amp; Accelerate your growth with the top 1%
            of Kenya’s developers
          </p>
          <button className={styles.heroBtn}>Hire Developers</button>
        </div>
      </section>
      <section className={styles.about}>
        <div className={styles.aboutContent}>
          <h2 className={styles.aboutTitle}>
            Bringing you the best of{" "}
            <span className={styles.aboutTitleEmphasis}>
              Kenya’s tech talent
            </span>
          </h2>
          <p className={styles.aboutText}>
            Talent is universal. Technology transcends geographies. We source
            and train the top 1% Kenyan software developers to solve your tech
            challenges and accelerate your growth.
          </p>
        </div>

        <div className={styles.aboutImgGrid}>
          <picture className={styles.aboutImg}>
            <source media="(max-width: 700px)" srcSet={AboutOneSmallWebp} />
            <source media="(max-width: 700px)" srcSet={AboutOneSmall} />
            <source media="(min-width: 701px)" srcSet={AboutOneWebp} />
            <img
              src={AboutOne}
              alt="Jenga developer at his desk on his laptop"
            />
          </picture>
          <picture className={styles.aboutImg}>
            <source media="(max-width: 700px)" srcSet={AboutTwoSmallWebp} />
            <source media="(max-width: 700px)" srcSet={AboutTwoSmall} />
            <source media="(min-width: 701px)" srcSet={AboutTwoWebp} />
            <img
              src={AboutTwo}
              alt="Jenga developers and their laptops in a room discussing"
            />
          </picture>
          <picture className={styles.aboutImg}>
            <source media="(max-width: 700px)" srcSet={AboutThreeSmallWebp} />
            <source media="(max-width: 700px)" srcSet={AboutThreeSmall} />
            <source media="(min-width: 701px)" srcSet={AboutThreeWebp} />
            <img
              src={AboutThree}
              alt="Jenga developer seated on a chair working on his laptop"
            />
          </picture>
        </div>
      </section>
      <section className={styles.whyJengaWrapper}>
        <div className={styles.whyJenga}>
          <h2 className={styles.whyJengaTitle}>Why Jenga?</h2>
          <div className={styles.whyJengaCardGrid}>
            <div className={styles.whyJengaCard}>
              <div className={styles.whyJengaCardImg}>
                <img
                  src={WhyJengaOne}
                  alt="Illustration of a lady and a gentleman working on their laptops"
                />
              </div>
              <div className={styles.whyJengaCardContent}>
                <h3 className={styles.whyJengaCardTitle}>
                  Native English-Speaking Top Talent
                </h3>
                <ul>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11.332"
                        height="15.501"
                        viewBox="0 0 11.332 15.501"
                      >
                        <path
                          fill="#f7df31"
                          d="M3.093 13.755a.929.929 0 0 0 .173.536l.55.778a1.049 1.049 0 0 0 .858.432H6.66a1.049 1.049 0 0 0 .858-.432l.55-.778a.928.928 0 0 0 .173-.536v-1.161h-5.15zM0 5.328a5.121 5.121 0 0 0 1.4 3.506A8.589 8.589 0 0 1 3.083 11.6v.024h5.163V11.6A8.589 8.589 0 0 1 9.93 8.834a5.121 5.121 0 0 0 1.4-3.505A5.506 5.506 0 0 0 5.649 0 5.478 5.478 0 0 0 0 5.328zm5.666-2.422a2.505 2.505 0 0 0-2.575 2.422.5.5 0 0 1-.515.484.5.5 0 0 1-.515-.484 3.507 3.507 0 0 1 3.605-3.39.5.5 0 0 1 .515.484.5.5 0 0 1-.515.484z"
                        />
                      </svg>
                    </div>
                    <span>Top 1% of Kenyan software engineers</span>
                  </li>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.191"
                        height="14.017"
                        viewBox="0 0 16.191 14.017"
                      >
                        <defs></defs>
                        <g id="Group_375">
                          <path
                            id="Path_628"
                            d="M1.655 4.961a4.676 4.676 0 0 1 1.51-3.4A5.127 5.127 0 0 1 6.654.141a5.235 5.235 0 0 1 2.918.919 4.7 4.7 0 0 1 1.822 2.32.225.225 0 0 0 .006.02c.458 1 .17 3.141-.062 4.861-.063.466-.122.906-.162 1.288v.022l-.031 4.586H4.237v-1.808l2.313.03a.212.212 0 0 0 .2-.221.218.218 0 0 0-.062-.15.192.192 0 0 0-.144-.058l-3.821.125A.961.961 0 0 1 2 11.78a1.094 1.094 0 0 1-.305-.754l-.022-2.533a.208.208 0 0 0-.2-.212s.379.052-.739 0 .9-3.229.9-3.229a.226.226 0 0 0 .021-.091zm0 0"
                            transform="translate(4.547 -.141)"
                          />
                          <path
                            id="Path_629"
                            d="M358.781 259.342c.158.093.268.547.111.64-1.376.821-1.376 1.589 0 2.41.105.06.037.4 0 .486a.367.367 0 0 1-.289.17.6.6 0 0 1-.392-.066c-1.689-1.008-1.689-2.632 0-3.64a.617.617 0 0 1 .57 0zm0 0"
                            transform="translate(-355.099 -251.149)"
                          />
                          <path
                            id="Path_630"
                            d="M408.153 232.249c.138.093.4.51.26.6-2.1 1.414-2.2 3.115-.1 4.552.089.061-.037.451-.071.534a.373.373 0 0 1-.253.216.479.479 0 0 1-.343-.064c-2.377-1.623-2.376-4.243 0-5.841a.486.486 0 0 1 .507.003zm.163 0"
                            transform="translate(-405.866 -225.133)"
                          />
                        </g>
                      </svg>
                    </div>
                    <span>Native English Speakers with neutral accents</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.whyJengaCard}>
              <div className={styles.whyJengaCardImg}>
                <img
                  src={WhyJengaTwo}
                  alt="Illustration of a lady with her laptop and her coffee on a desk"
                />
              </div>
              <div className={styles.whyJengaCardContent}>
                <h3 className={styles.whyJengaCardTitle}>Flexibility</h3>
                <ul>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14.889"
                        height="14.889"
                        viewBox="0 0 14.889 14.889"
                      >
                        <path
                          fill="#f7df31"
                          d="M8.007.563a7.444 7.444 0 1 0 7.444 7.444A7.443 7.443 0 0 0 8.007.563zm1.714 10.509L7.073 9.148a.363.363 0 0 1-.147-.291V3.8a.361.361 0 0 1 .36-.36h1.441a.361.361 0 0 1 .36.36v4.138l1.906 1.387a.36.36 0 0 1 .078.5l-.847 1.165a.363.363 0 0 1-.503.082z"
                          transform="translate(-.563 -.563)"
                        />
                      </svg>
                    </div>

                    <span>
                      Full working hours overlap (EU) or adjusted working hours
                      (US/Canada)
                    </span>
                  </li>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18.061"
                        height="12.79"
                        viewBox="0 0 18.061 12.79"
                      >
                        <path
                          fill="#f7df31"
                          d="M12.994 12.4A3.2 3.2 0 1 0 9.71 9.2a3.241 3.241 0 0 0 3.284 3.2zM5.6 10.8V8.4H3.963v2.4H1.5v1.6h2.463v2.4H5.6v-2.4h2.468v-1.6zm7.389 3.2c-2.192 0-6.568 1.071-6.568 3.2v1.6h13.14v-1.6c0-2.135-4.375-3.206-6.567-3.206z"
                          transform="translate(-1.5 -6)"
                        />
                      </svg>
                    </div>
                    <span>New developer joins within days</span>
                  </li>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="payrate-icon"
                        width="14.464"
                        height="14.58"
                        viewBox="0 0 14.464 14.58"
                      >
                        <g
                          id="dollars-money-bag-with-a-clock"
                          transform="translate(3.978 5.927)"
                        >
                          <g
                            id="money_time"
                            transform="translate(5.835 -2.383)"
                          >
                            <g id="Group_218">
                              <path
                                id="Path_632"
                                d="M22.342 7.73a.367.367 0 0 0-.05-.076l-.322-1.863-.341 1.884a.41.41 0 0 0-.079.243.42.42 0 0 0 .419.42.4.4 0 0 0 .137-.025l1.268.148-1.032-.735z"
                                transform="translate(-21.551 -5.791)"
                              />
                            </g>
                          </g>
                        </g>
                        <path
                          id="Path_631"
                          d="M10.331 1.029a4.154 4.154 0 0 0-2.274.678A1.983 1.983 0 0 0 7.9.289C7.108-.8 5.791 1.572 5.186 1.33S3.291-.182 2.436.335C1.7.783 2.9 3.787 3.482 4.221a9.2 9.2 0 0 0 1.859.224c.344 0 .642-.019.883-.042a4.169 4.169 0 0 0-.076.687c-.28.025-.564.043-.855.043a9.6 9.6 0 0 1-2.076-.224C2.068 5.841.056 9.153.056 10.6c0 2.6 2.283 3.984 5.1 3.984s5.1-1.38 5.1-3.983a3.945 3.945 0 0 0-.241-1.167c.1.009.208.016.314.016a4.208 4.208 0 0 0 0-8.416zM6.749 11.407a1.069 1.069 0 0 1-.241.333 1.226 1.226 0 0 1-.365.231 1.4 1.4 0 0 1-.458.1v.348h-.768v-.452l-.117-.048c-.039-.016-.076-.034-.112-.051v.17h-.769v-1.157h.768a1.686 1.686 0 0 0 .2.19.964.964 0 0 0 .2.132.781.781 0 0 0 .224.077 1.422 1.422 0 0 0 .283.026.642.642 0 0 0 .346-.086.255.255 0 0 0 .129-.22.3.3 0 0 0-.069-.2.61.61 0 0 0-.184-.146 1.151 1.151 0 0 0-.246-.1 2.587 2.587 0 0 0-.27-.054 2.362 2.362 0 0 1-.746-.221 1.446 1.446 0 0 1-.43-.325.9.9 0 0 1-.2-.361 1.361 1.361 0 0 1-.046-.328 1.035 1.035 0 0 1 .293-.729 1.2 1.2 0 0 1 .329-.244 1.312 1.312 0 0 1 .415-.128V7.8h.768v.42a1.294 1.294 0 0 1 .308.131v-.168h.769V9.34h-.773c-.062-.069-.122-.132-.181-.185a.89.89 0 0 0-.187-.131.933.933 0 0 0-.219-.08 1.21 1.21 0 0 0-.277-.028.511.511 0 0 0-.353.11.318.318 0 0 0-.123.237c0 .238.255.4.768.474a2.16 2.16 0 0 1 .759.234 1.442 1.442 0 0 1 .43.352.958.958 0 0 1 .19.373 1.5 1.5 0 0 1 .041.3.978.978 0 0 1-.086.411zm3.931-2.941l-.35-.418-.35.418A3.244 3.244 0 0 1 7.118 5.6l.462-.389-.454-.385a3.243 3.243 0 0 1 2.863-2.82l.341.408.341-.408a3.245 3.245 0 0 1 2.863 2.817l-.49.412.49.414a3.242 3.242 0 0 1-2.854 2.817z"
                          transform="translate(-.056)"
                        />
                      </svg>
                    </div>

                    <span>Pay as you go with 1 month notice</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.whyJengaCard}>
              <div className={styles.whyJengaCardImg}>
                <img
                  src={WhyJengaThree}
                  alt="Illustration of a lady holding a credit card"
                />
              </div>
              <div className={styles.whyJengaCardContent}>
                <h3 className={styles.whyJengaCardTitle}>Cost</h3>
                <ul>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14.326"
                        height="15.543"
                        viewBox="0 0 14.326 15.543"
                      >
                        <path
                          fill="#f7df31"
                          d="M13.7 7.868c1.606 0 2.2.734 2.255 1.813h1.994a3.484 3.484 0 0 0-2.9-3.29V4.5h-2.698v1.865a5.5 5.5 0 0 0-1.335.466L12.342 8.1a3.678 3.678 0 0 1 1.358-.232zM7.236 5.415L6.09 6.512l3.1 2.97c0 1.8 1.407 2.772 3.527 3.376l3.167 3.031a2.551 2.551 0 0 1-2.183.786c-1.858 0-2.589-.794-2.688-1.813H9.031c.108 1.891 1.588 2.953 3.32 3.307v1.874h2.707v-1.857a4.607 4.607 0 0 0 2.21-.967l2 1.917 1.146-1.1z"
                          transform="translate(-6.09 -4.5)"
                        />
                      </svg>
                    </div>

                    <span>No recruiting fee</span>
                  </li>
                  <li>
                    <div className={styles.whyJengaCardIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.23"
                        height="10.491"
                        viewBox="0 0 17.23 10.491"
                      >
                        <path
                          fill="#f7df31"
                          d="M9.477 10.62h-.431v-2.4A.217.217 0 0 0 8.83 8h-.365a.639.639 0 0 0-.358.11l-.413.279a.22.22 0 0 0-.06.3l.239.364a.213.213 0 0 0 .3.061l.013-.008v1.514h-.432a.217.217 0 0 0-.215.219v.437a.217.217 0 0 0 .215.219h1.723a.217.217 0 0 0 .215-.219v-.437a.217.217 0 0 0-.215-.219zm6.892-6.12H.862A.868.868 0 0 0 0 5.374v8.743a.868.868 0 0 0 .862.874h15.507a.868.868 0 0 0 .862-.874V5.374a.868.868 0 0 0-.862-.874zM1.292 13.68v-1.749a1.736 1.736 0 0 1 1.723 1.749zm0-6.12V5.811h1.723A1.736 1.736 0 0 1 1.292 7.56zm7.323 5.246a2.853 2.853 0 0 1-2.585-3.06 2.852 2.852 0 0 1 2.585-3.06 2.852 2.852 0 0 1 2.585 3.06 2.853 2.853 0 0 1-2.585 3.06zm7.323.874h-1.723a1.736 1.736 0 0 1 1.723-1.749zm0-6.12a1.736 1.736 0 0 1-1.723-1.749h1.723z"
                          transform="translate(0 -4.5)"
                        />
                      </svg>
                    </div>

                    <span>
                      Transparent, stable, and highly competitive daily rate
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.clients}>
        <h2 className={styles.clientsTitle}>They have grown with Jenga</h2>
        <div className={styles.clientsImgGrid}>
          <img
            src={ClientOne}
            alt="ABC Expat company logo"
            className={styles.clientsImg}
          />
          <img
            src={ClientTwo}
            alt="Altaroad company logo"
            className={styles.clientsImg}
          />
          <img
            src={ClientThree}
            alt="Artefact company logo"
            className={styles.clientsImg}
          />
          <img
            src={ClientFour}
            alt="Koko networks company logo"
            className={styles.clientsImg}
          />
          <img
            src={ClientFive}
            alt="LooksGood AI company logo"
            className={styles.clientsImg}
          />
          <img
            src={ClientSix}
            alt="UnblockData company logo"
            className={styles.clientsImg}
          />
        </div>
      </section>

      <section className={styles.works}>
        <h2 className={styles.worksTitle}>How it works</h2>

        <div className={styles.worksCard}>
          <div className={styles.worksCardImg}>
            <img
              src={WorksTwo}
              alt="illustration of a man wearing headphones typing on his laptop"
            />
            <h3 className={styles.worksCardTitle}>Who are Jenga Developers?</h3>
          </div>
          <div className={styles.worksCardContent}>
            <ul>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Top 1% talent
                  </span>{" "}
                  right after CS degree/education, eager to learn
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Thought leaders
                  </span>{" "}
                  – Expect questions and engagement, not blind execution
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Trained on communication
                  </span>{" "}
                  to work in a remote environment
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  Worked on projects and has{" "}
                  <span className={styles.worksCardEmphasis}>
                    1+ year(s) work experience
                  </span>
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>Expertise</span> in
                  either front-end and/or back-end
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.wavyLine}>
          <img
            src={WavyLineOne}
            alt="wavy dotted line"
            className={styles.wavyLineImg}
          />
        </div>
        <div className={styles.worksCard}>
          <div className={styles.worksCardImg}>
            <img
              src={WorksOne}
              alt="illustration of a man wearing headphones typing on his laptop"
            />
            <h3 className={styles.worksCardTitle}>
              How to make the most out of Jenga developers
            </h3>
          </div>
          <div className={styles.worksCardContent}>
            <ul>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Have a Project Manager
                  </span>{" "}
                  to prioritize your workload
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Have a CTO/senior developer
                  </span>{" "}
                  to guide them initially in your stack, help them grow with you
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    Ideally, have a full tech team
                  </span>{" "}
                  to fully leverage the talent
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.wavyLine}>
          <img
            src={WavyLineTwo}
            alt="wavy dotted line"
            className={styles.wavyLineImg}
          />
        </div>
        <div className={styles.worksCard}>
          <div className={styles.worksCardImg}>
            <img
              src={WorksThree}
              alt="illustration of a man wearing headphones typing on his laptop"
            />
            <h3 className={styles.worksCardTitle}>
              You hired a Jenga Developer. Now what?
            </h3>
          </div>
          <div className={styles.worksCardContent}>
            <ul>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  <span className={styles.worksCardEmphasis}>
                    The Jenga developer fully integrates into your team
                  </span>
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  She/he{" "}
                  <span className={styles.worksCardEmphasis}>
                    has access to your tools
                  </span>{" "}
                  (e.g., Github, Slack, JIRA)
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  She/he{" "}
                  <span className={styles.worksCardEmphasis}>
                    works from the Jenga office
                  </span>{" "}
                  with Jenga hardware
                </span>
              </li>
              <li>
                <img src={TickIcon} alt="Tick Icon in yellow" />
                <span>
                  At the end of the month,{" "}
                  <span className={styles.worksCardEmphasis}>
                    you pay per day worked
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className={styles.stack}>
        <div className={styles.stackCardGrid}>
          <div className={styles.stackCard}>
            <img
              src={StackOne}
              alt="Javascript Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Javascript</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackTwo}
              alt="React Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>React</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackThree}
              alt="Vue Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Vue</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackFour}
              alt="Angular Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Angular</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackFive}
              alt="Python Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Python</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackSix}
              alt="Django Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Django</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackSeven}
              alt="Flask Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Flask</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackEight}
              alt="Node Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Node</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackNine}
              alt="Amazon Web Services Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>AWS</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackTen}
              alt="Google cloud platform Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>GCP</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackEleven}
              alt="Postgresql Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>Postgresql</h3>
          </div>
          <div className={styles.stackCard}>
            <img
              src={StackTwelve}
              alt="my sequal Logo"
              className={styles.stackCardImg}
            />
            <h3 className={styles.stackCardTitle}>MySQL</h3>
          </div>
        </div>
        <div className={styles.stackContent}>
          <h2 className={styles.stackTitle}>Our Stack</h2>
          <p className={styles.stackIntro}>
            Our software engineers are proficient with the latest technologies,
            whether front-end, back-end and DevOps. Based on your stack, we find
            the best skills match to fit your needs.
          </p>
        </div>
      </section>

      <section className={styles.testimonialsWrapper}>
        <div className={styles.testimonials}>
          <h2 className={styles.testimonialsTitle}>What our clients say</h2>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="27.88"
            viewBox="0 0 30 27.88"
            className={styles.testimonialsIcon}
          >
            <g>
              <path
                fill="#fff"
                d="M12.917 13.562v5.006a1.229 1.229 0 0 1-1.229 1.232c-2.422 0-3.74 2.484-3.923 7.388h3.923a1.229 1.229 0 0 1 1.229 1.229v10.57a1.229 1.229 0 0 1-1.229 1.229H1.229A1.229 1.229 0 0 1 0 38.984v-10.57A27.106 27.106 0 0 1 .7 22a15.428 15.428 0 0 1 2.183-5.075A10.655 10.655 0 0 1 6.6 13.538a10.557 10.557 0 0 1 5.093-1.205 1.229 1.229 0 0 1 1.224 1.229zM28.771 19.8A1.23 1.23 0 0 0 30 18.568v-5.006a1.229 1.229 0 0 0-1.229-1.229 10.209 10.209 0 0 0-8.8 4.595A15.435 15.435 0 0 0 17.786 22a27.126 27.126 0 0 0-.7 6.412v10.57a1.229 1.229 0 0 0 1.229 1.229h10.456A1.229 1.229 0 0 0 30 38.984v-10.57a1.229 1.229 0 0 0-1.229-1.229H24.9c.184-4.903 1.482-7.385 3.871-7.385z"
                transform="translate(0 -12.333)"
              />
            </g>
          </svg>

          <div className={styles.testimonialsCard}>
            <p className={styles.testimonialsCardText}>
              <span className={styles.testimonialsCardEmphasis}>
                Within days, Jenga found the right engineer
              </span>{" "}
              to help develop our client web app. He has been working remotely
              in perfect sync with our tech team, with daily slack messages and
              weekly team calls.
            </p>
            <div className={styles.testimonialsCardClient}>
              <img
                src={Cecile}
                alt="ceo of Altaroad"
                className={styles.testimonialsCardImg}
              />
              <div>
                <h3>Cecile Villette</h3>
                <p>CEO, Altaroad</p>
              </div>
            </div>
          </div>

          <div className={styles.testimonialsCard}>
            <p className={styles.testimonialsCardText}>
              The Jenga developer{" "}
              <span className={styles.testimonialsCardEmphasis}>
                integrated smoothly in our team of 20+ software engineers
              </span>{" "}
              to help us deliver on a tight product deadline for our national
              product launch. He was great, so we extended past the launch.
            </p>
            <div className={styles.testimonialsCardClient}>
              <img
                src={Sameer}
                alt="principal engineer at koko networks"
                className={styles.testimonialsCardImg}
              />
              <div>
                <h3>Sameer Soni</h3>
                <p>Principal Engineer, KOKO Networks</p>
              </div>
            </div>
          </div>

          <div>
            <p className={styles.testimonialsCardText}>
              <span className={styles.testimonialsCardEmphasis}>
                We needed to ramp up
              </span>{" "}
              the front- end development of a data marketing app for a major
              client.{" "}
              <span className={styles.testimonialsCardEmphasis}>
                The two remote Jenga developers worked seamlessly with my team
              </span>{" "}
              and 4 months later, we reduced to one to maintain and improve the
              stabilized app, and shifted the second developer to another
              Artefact project.
            </p>
            <div className={styles.testimonialsCardClient}>
              <div>
                <h3>Partner</h3>
                <p>Artefact</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.buildTeam}>
        <h2 className={styles.buildTeamTitle}>
          Let’s build your tech team together
        </h2>
        <div className={styles.buildTeamCard}>
          <img
            src={ChatStack}
            alt="illustration of two people within boxes talking"
            className={styles.buildTeamCardImg}
          />
          <div className={styles.buildTeamCardContent}>
            <h3 className={styles.buildTeamCardTitle}>
              <div>1</div>
              Chat on Stack
            </h3>
            <p className={styles.buildTeamCardText}>
              We have a 30-minute chat to better understand your tech stack,
              current team setup &amp; desired skillset.
            </p>
          </div>
        </div>
        <img
          src={WavyLineThree}
          alt="Wavy dotted line"
          className={styles.wavyLine}
        />
        <div className={styles.buildTeamCardReverse}>
          <img
            src={SourceTrain}
            alt="Illustration of person holding a magnifying glass to magnify a list with people's profiles"
            className={styles.buildTeamCardImg}
          />
          <div className={styles.buildTeamCardContent}>
            <h3 className={styles.buildTeamCardTitle}>
              <div>2</div>
              Source and Train
            </h3>
            <p className={styles.buildTeamCardText}>
              If not already working for us, we find the right talent and train
              them to fit your stack.
            </p>
          </div>
        </div>
        <img
          src={WavyLineFour}
          alt="Wavy dotted line"
          className={styles.wavyLine}
        />
        <div className={styles.buildTeamCard}>
          <img
            src={HireOnboard}
            alt="Illustration of a person standing next to an enlarged illustrated web page"
            className={styles.buildTeamCardImg}
          />
          <div className={styles.buildTeamCardContent}>
            <h3 className={styles.buildTeamCardTitle}>
              <div>3</div>
              Hire and Onboard
            </h3>
            <p className={styles.buildTeamCardText}>
              Equipped with appropriate communication and development tracking
              tools, our developer seamlessly fits in your team.
            </p>
          </div>
        </div>
        <img
          src={WavyLineThree}
          alt="Wavy dotted line"
          className={styles.wavyLine}
        />
        <div className={styles.buildTeamCardReverse}>
          <img
            src={Deliver}
            alt="Illustration of a man leaning against delivery boxes"
            className={styles.buildTeamCardImg}
          />
          <div className={styles.buildTeamCardContent}>
            <h3 className={styles.buildTeamCardTitle}>
              <div>4</div>
              Deliver
            </h3>
            <p className={styles.buildTeamCardText}>
              Feature after feature, our developer will remotely deliver for
              your product. And you’ll get one simple monthly invoice.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.contactWrapper}>
        <div className={styles.contact}>
          <h2 className={styles.contactTitle}>
            Hire Jenga developers and{" "}
            <span className={styles.contactTitleEmphasis}>
              build your products with us!
            </span>
          </h2>

          <div className={styles.contactForm}>
            <h3 className={styles.contactFormTitle}>Contact Us</h3>
            <form
              className={styles.form}
              onSubmit={handleSubmit(submitHandler)}
            >
              <div className={styles.formGroup}>
                <label htmlFor="emailID" className={styles.formLabel}>
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="emailID"
                  placeholder="Your Email"
                  className={styles.formControl}
                  ref={register}
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="reasonID" className={styles.formLabel}>
                  What brings you here today
                </label>
                <select
                  name="reason"
                  id="reasonID"
                  placeholder="Choose an Option"
                  className={styles.formControl}
                  ref={register}
                >
                  <option>Choose an option</option>
                  <option value="info">Info</option>
                  <option value="info2">Info2</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="messageID" className={styles.formLabel}>
                  Message
                </label>
                <textarea
                  name="message"
                  id="messageID"
                  cols={30}
                  rows={10}
                  className={styles.formControl}
                  placeholder="Type Message"
                  ref={register}
                ></textarea>
              </div>
              <button className={styles.contactSubmit}>Submit Form</button>
            </form>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
